import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export default function useDeleteTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (skillId: string) => api.delete(`/tenant/custom-skills/${skillId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] });
    },
  });
}
